module.exports = __webpack_public_path__ + "static/Yi Feng.ed32d461.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Yi Feng.jpg
// module id = 1245
// module chunks = 6166952557895